import { AuditLogs } from "../../components/Group/auditLogs";
import NameHeading from "../../components/NameHeading";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { selectGroupById } from "../../features/groups/groupSlice";

const GroupAuditLogsRoute = (): JSX.Element => {
  const { groupid } = useParams<{ groupid: string }>();
  const group = useAppSelector((state) => selectGroupById(state, groupid ?? ""));
  return (
    <>
      {group && <NameHeading name={group.name} />}
      <AuditLogs />
    </>
  );
};

export default GroupAuditLogsRoute;
